import productHelper from '../helpers/productHelper'

import Product from './Product/Product'
import ProductLite from './Product/ProductLite'
import ProductCardWithBundle from './ProductCardWithBundle'
import { ProductOptionName } from './ProductOption'
import { ProductVariantOption } from './ProductVariant'

interface IProductCard {
  readonly product: Product | ProductLite
  readonly selectedOptions: ProductVariantOption[]
}

export default class ProductCard implements IProductCard {
  readonly product: Product | ProductLite
  readonly selectedOptions: ProductVariantOption[]

  constructor({ product, selectedOptions = [] }: IProductCard) {
    const cascadingProductOptions = productHelper.getCascadingProductOptions(product, selectedOptions)
    product = { ...product, productOptions: cascadingProductOptions }
    this.product = product
    this.selectedOptions = selectedOptions
    return {
      ...this,
    }
  }

  static getProductCardIdentifier(productCard: ProductCard | ProductCardWithBundle) {
    return `${productCard.product.id}_${productCard.selectedOptions.map(x => x.value).join('_')}`
  }

  static getSelectedColorValue(selectedOptions: ProductVariantOption[]): string | undefined {
    return selectedOptions.find(x => x.name === ProductOptionName.Color)?.value
  }
}
